import { Order } from '../../modules/orders/order.types';
import { CopiedGrid } from '../../modules/orders/orderState.types';
import { AvailabilityEnum } from '../../modules/products/ProductTypes';
import { IProductDetailsGridParams } from '../../services/modules/productDetails/productDetails.types';
import { OrderFilterStateEnum } from '../ProductDetailsFilter/productDetailsFilter.types';

export enum ProductDetailsOriginType {
  CATALOG = 'CATALOG',
}

export interface ProductDetailsOrigin {
  type: ProductDetailsOriginType;
  id: string;
}

export interface IProductDetailsModal {
  isOpen: boolean;
  kitId?: string;
  productId?: string;
  customerId?: string;
  disableGrid?: boolean;
  disablePrice?: boolean;
  productColorId?: string;
}

export interface MassActionCombinationItem {
  orderId: string;
  productColorId: string;
  availability: AvailabilityEnum;
  deliveryWindowId?: string;
}

export type MassActionCombinationItemsById = Record<string, MassActionCombinationItem>;

export interface PasteGridMassAction {
  isAllItemsSelected: boolean;
  items: MassActionCombinationItemsById;
  unselectedItems: MassActionCombinationItemsById;
}

export interface OpenedByOrderBookParams {
  state: boolean;
  productColorId?: string;
  productId?: string;
  kitId?: string;
  from?: ProductDetailsOrigin;
}

export interface ProductDetailsState {
  ordersFilterState: OrderFilterStateEnum;
  relatedProductsFilterState: boolean;
  productDetailsModalState: IProductDetailsModal;
  productGridParams: IProductDetailsGridParams;
  hasSuggestedProducts?: boolean;
  isMobileHeaderFixed: boolean;
  copiedGrid: CopiedGrid;
  finishedOrder?: Order;
  cleanOrderId?: { orderId?: string; flag: boolean };
  openedByOrderBook?: OpenedByOrderBookParams;
  from?: ProductDetailsOrigin;
  pasteGridMassAction: PasteGridMassAction;
  pastedCombinationKeys: string[];
  mediaProductColorId?: string;
}

export type SetPasteGridMassActionParams = PasteGridMassAction;

interface ProductDetailsActions {
  resetFilters: () => void;
  removeCopiedGrid: () => void;
  resetFilterWithOrders: () => void;
  resetProductDetailsStore: () => void;
  copyGrid: (grid: CopiedGrid) => void;
  markCombinationAsPasted: (combinationKey: string) => void;
  setFinishedOrder: (order?: Order) => void;
  setIsMobileHeaderFixed: (flag: boolean) => void;
  setHasSuggestedProducts: (state?: boolean) => void;
  handleChangeOrderFilterState: (state: OrderFilterStateEnum) => void;
  setCleanOrderId: (orderId: { orderId: string; flag: boolean }) => void;
  handleChangeProductGridParams: (params: IProductDetailsGridParams) => void;
  handleOpenProductDetailsModal: (
    params: IProductDetailsGridParams,
    filterByRelatedProducts?: boolean,
  ) => void;
  toggleRelatedProductsFilterState: (newState: boolean) => void;
  setProductDetailsModalState: (productDetailsModalState: IProductDetailsModal) => void;
  setOpenedByOrderBook: (params: OpenedByOrderBookParams) => void;
  setFrom: (from?: ProductDetailsOrigin) => void;
  setMediaProductColorId: (productColorId?: string) => void;
  setPasteGridMassAction: (newState: SetPasteGridMassActionParams) => void;
  resetPasteGridMassAction: () => void;
  toggleCombinationMassActionSelection: (item: MassActionCombinationItem) => void;
}
export type ProductDetailsStore = ProductDetailsState & ProductDetailsActions;
